export default __webpack_public_path__ + "static/media/Systematic-Withdrawal-Plan-with-Estate-Planner.a7d99690.png";